// MAABAR product taxonomy — 13 top categories → visual sections → leaf subcategories.
// Products are tagged with a LEAF `subcategory` code; the top category is derived.
// Sections are for on-screen grouping only (not a filter level).

export const CATEGORY_TREE = [
  { code: 'electronics', ar: 'الإلكترونيات', en: 'Electronics', icon: '📱', sections: [
    { ar: 'الأجهزة الذكية', en: 'Smart devices', subs: [
      { code: 'phones', ar: 'جوالات', en: 'Phones' },
      { code: 'tablets', ar: 'أجهزة لوحية', en: 'Tablets' },
      { code: 'smartwatches', ar: 'ساعات ذكية', en: 'Smartwatches' },
      { code: 'phone_accessories', ar: 'إكسسوارات الجوال', en: 'Phone accessories' },
    ]},
    { ar: 'الصوت والصورة', en: 'Audio & Video', subs: [
      { code: 'headphones', ar: 'سماعات', en: 'Headphones' },
      { code: 'speakers', ar: 'مكبرات صوت', en: 'Speakers' },
      { code: 'cameras', ar: 'كاميرات', en: 'Cameras' },
    ]},
    { ar: 'الحوسبة والطاقة', en: 'Computing & Power', subs: [
      { code: 'laptops', ar: 'لابتوب وإكسسوارات', en: 'Laptops & accessories' },
      { code: 'storage', ar: 'تخزين', en: 'Storage' },
      { code: 'cables_chargers', ar: 'كابلات وشواحن', en: 'Cables & chargers' },
    ]},
    { ar: 'مكوّنات', en: 'Components', subs: [
      { code: 'electronic_components', ar: 'مكوّنات وقطع إلكترونية', en: 'Electronic components' },
    ]},
  ]},

  { code: 'home_appliances', ar: 'الأجهزة المنزلية', en: 'Home Appliances', icon: '🔌', sections: [
    { ar: 'أجهزة المطبخ', en: 'Kitchen appliances', subs: [
      { code: 'small_kitchen_appliances', ar: 'أجهزة مطبخ صغيرة', en: 'Small kitchen appliances' },
      { code: 'large_kitchen_appliances', ar: 'أجهزة مطبخ كبيرة', en: 'Large kitchen appliances' },
    ]},
    { ar: 'التنظيف', en: 'Cleaning', subs: [
      { code: 'vacuum_cleaners', ar: 'مكانس', en: 'Vacuum cleaners' },
      { code: 'cleaning_appliances', ar: 'أجهزة تنظيف', en: 'Cleaning appliances' },
    ]},
    { ar: 'المناخ', en: 'Climate', subs: [
      { code: 'fans', ar: 'مراوح', en: 'Fans' },
      { code: 'heating_cooling', ar: 'تكييف وتدفئة', en: 'Heating & cooling' },
      { code: 'air_purifiers', ar: 'تنقية هواء', en: 'Air purifiers' },
    ]},
    { ar: 'العناية الشخصية الكهربائية', en: 'Personal care', subs: [
      { code: 'hair_dryers', ar: 'مجففات', en: 'Hair dryers' },
      { code: 'shavers', ar: 'ماكينات حلاقة', en: 'Shavers' },
    ]},
  ]},

  { code: 'apparel', ar: 'الأزياء والمنسوجات', en: 'Apparel & Textiles', icon: '👕', sections: [
    { ar: 'الملابس', en: 'Clothing', subs: [
      { code: 'mens_clothing', ar: 'رجالي', en: 'Men' },
      { code: 'womens_clothing', ar: 'نسائي', en: 'Women' },
      { code: 'kids_clothing', ar: 'أطفال', en: 'Kids' },
      { code: 'sportswear', ar: 'ملابس رياضية', en: 'Sportswear' },
    ]},
    { ar: 'أحذية وحقائب', en: 'Footwear & Bags', subs: [
      { code: 'footwear', ar: 'أحذية', en: 'Footwear' },
      { code: 'bags', ar: 'حقائب', en: 'Bags' },
    ]},
    { ar: 'إكسسوارات', en: 'Accessories', subs: [
      { code: 'hats', ar: 'قبعات', en: 'Hats' },
      { code: 'belts', ar: 'أحزمة', en: 'Belts' },
      { code: 'eyewear', ar: 'نظارات', en: 'Eyewear' },
    ]},
    { ar: 'الأقمشة', en: 'Fabrics', subs: [
      { code: 'fabrics', ar: 'أقمشة وخامات', en: 'Fabrics & materials' },
    ]},
  ]},

  { code: 'furniture', ar: 'الأثاث', en: 'Furniture', icon: '🛋️', sections: [
    { ar: 'المنزل', en: 'Home', subs: [
      { code: 'bedroom', ar: 'غرف نوم', en: 'Bedroom' },
      { code: 'sofas', ar: 'كنب وصالات', en: 'Sofas & living' },
      { code: 'tables_chairs', ar: 'طاولات وكراسي', en: 'Tables & chairs' },
    ]},
    { ar: 'المكتب', en: 'Office', subs: [
      { code: 'office_desks', ar: 'مكاتب', en: 'Desks' },
      { code: 'office_chairs', ar: 'كراسي مكتب', en: 'Office chairs' },
      { code: 'cabinets', ar: 'خزائن', en: 'Cabinets' },
    ]},
    { ar: 'المطبخ والتخزين', en: 'Kitchen & Storage', subs: [
      { code: 'kitchen_cabinets', ar: 'خزائن مطبخ', en: 'Kitchen cabinets' },
      { code: 'storage_units', ar: 'وحدات تخزين', en: 'Storage units' },
    ]},
    { ar: 'خارجي', en: 'Outdoor', subs: [
      { code: 'garden_furniture', ar: 'أثاث حدائق', en: 'Garden furniture' },
      { code: 'camping_outdoor', ar: 'التخييم والرحلات', en: 'Camping & outdoor' },
    ]},
  ]},

  { code: 'home_living', ar: 'المنزل والمطبخ والديكور', en: 'Home, Kitchen & Décor', icon: '🏠', sections: [
    { ar: 'المطبخ والطعام', en: 'Kitchen & Dining', subs: [
      { code: 'cookware', ar: 'أدوات الطبخ', en: 'Cookware' },
      { code: 'tableware', ar: 'أدوات المائدة', en: 'Tableware' },
      { code: 'drinkware', ar: 'أكواب ومستلزمات المشروبات', en: 'Drinkware' },
    ]},
    { ar: 'المنزل', en: 'Home', subs: [
      { code: 'organization_storage', ar: 'تنظيم وتخزين', en: 'Organization & storage' },
      { code: 'bath', ar: 'الحمام', en: 'Bath' },
      { code: 'home_textiles', ar: 'المنسوجات المنزلية', en: 'Home textiles' },
    ]},
    { ar: 'الديكور', en: 'Décor', subs: [
      { code: 'decor', ar: 'ديكور', en: 'Décor' },
      { code: 'lighting', ar: 'إضاءة', en: 'Lighting' },
    ]},
  ]},

  { code: 'building', ar: 'مواد البناء والأجهزة', en: 'Building & Hardware', icon: '🧱', sections: [
    { ar: 'الإنشاء', en: 'Construction', subs: [
      { code: 'tiles_flooring', ar: 'بلاط وأرضيات', en: 'Tiles & flooring' },
      { code: 'doors_windows', ar: 'أبواب ونوافذ', en: 'Doors & windows' },
      { code: 'paint', ar: 'دهانات', en: 'Paint' },
    ]},
    { ar: 'الصحية والكهرباء', en: 'Plumbing & Electrical', subs: [
      { code: 'sanitary', ar: 'أدوات صحية', en: 'Sanitary ware' },
      { code: 'electrical_fittings', ar: 'تمديدات كهربائية', en: 'Electrical fittings' },
    ]},
    { ar: 'العدد والأدوات', en: 'Tools & Hardware', subs: [
      { code: 'tools', ar: 'عدد يدوية وكهربائية', en: 'Hand & power tools' },
      { code: 'fasteners', ar: 'مسامير وتثبيت', en: 'Fasteners' },
    ]},
  ]},

  { code: 'auto_parts', ar: 'قطع غيار السيارات', en: 'Auto Parts', icon: '🚗', sections: [
    { ar: 'الميكانيكا', en: 'Mechanical', subs: [
      { code: 'engine_parts', ar: 'المحرك', en: 'Engine' },
      { code: 'brakes', ar: 'الفرامل', en: 'Brakes' },
      { code: 'suspension', ar: 'التعليق', en: 'Suspension' },
    ]},
    { ar: 'الكهرباء', en: 'Electrical', subs: [
      { code: 'batteries', ar: 'بطاريات', en: 'Batteries' },
      { code: 'auto_lighting', ar: 'إضاءة', en: 'Lighting' },
      { code: 'sensors', ar: 'حساسات', en: 'Sensors' },
    ]},
    { ar: 'الإكسسوارات والعناية', en: 'Accessories & Care', subs: [
      { code: 'interior_accessories', ar: 'إكسسوارات داخلية', en: 'Interior' },
      { code: 'exterior_accessories', ar: 'إكسسوارات خارجية', en: 'Exterior' },
      { code: 'car_care', ar: 'منتجات عناية', en: 'Car care' },
    ]},
  ]},

  { code: 'machinery', ar: 'الآلات والمعدات الصناعية', en: 'Machinery', icon: '⚙️', sections: [
    { ar: 'الآلات', en: 'Machines', subs: [
      { code: 'manufacturing_machines', ar: 'آلات التصنيع', en: 'Manufacturing machines' },
      { code: 'packaging_machines', ar: 'معدات التعبئة والتغليف', en: 'Packaging machines' },
    ]},
    { ar: 'القطع', en: 'Parts', subs: [
      { code: 'industrial_parts', ar: 'قطع ومكوّنات صناعية', en: 'Industrial parts' },
    ]},
  ]},

  { code: 'packaging', ar: 'التغليف والطباعة', en: 'Packaging & Printing', icon: '📦', sections: [
    { ar: 'التغليف', en: 'Packaging', subs: [
      { code: 'boxes', ar: 'صناديق وكراتين', en: 'Boxes & cartons' },
      { code: 'bags_pouches', ar: 'أكياس', en: 'Bags & pouches' },
      { code: 'containers', ar: 'حاويات', en: 'Containers' },
    ]},
    { ar: 'الطباعة', en: 'Printing', subs: [
      { code: 'labels_stickers', ar: 'ملصقات', en: 'Labels & stickers' },
      { code: 'promo_print', ar: 'مطبوعات دعائية', en: 'Promotional print' },
    ]},
    { ar: 'المواد', en: 'Materials', subs: [
      { code: 'packaging_materials', ar: 'مواد التغليف', en: 'Packaging materials' },
    ]},
  ]},

  { code: 'toys', ar: 'الألعاب', en: 'Toys & Games', icon: '🧸', sections: [
    { ar: 'الألعاب', en: 'Toys', subs: [
      { code: 'educational_toys', ar: 'ألعاب تعليمية', en: 'Educational' },
      { code: 'kids_toys', ar: 'ألعاب أطفال', en: 'Kids toys' },
      { code: 'electronic_toys', ar: 'ألعاب إلكترونية', en: 'Electronic toys' },
      { code: 'outdoor_toys', ar: 'ألعاب خارجية', en: 'Outdoor toys' },
    ]},
  ]},

  { code: 'beauty', ar: 'الجمال والعناية', en: 'Beauty & Personal Care', icon: '💄', sections: [
    { ar: 'العناية', en: 'Care', subs: [
      { code: 'skincare', ar: 'العناية بالبشرة', en: 'Skincare' },
      { code: 'haircare', ar: 'العناية بالشعر', en: 'Haircare' },
      { code: 'makeup', ar: 'مكياج', en: 'Makeup' },
      { code: 'beauty_tools', ar: 'أدوات ومستلزمات تجميل', en: 'Beauty tools' },
    ]},
  ]},

  { code: 'hospitality', ar: 'مستلزمات الضيافة', en: 'Hospitality', icon: '🏨', sections: [
    { ar: 'الفنادق', en: 'Hotels', subs: [
      { code: 'hotel_furnishings', ar: 'مفروشات', en: 'Furnishings' },
      { code: 'room_supplies', ar: 'مستلزمات غرف', en: 'Room supplies' },
    ]},
    { ar: 'المطاعم والمقاهي', en: 'F&B', subs: [
      { code: 'serving_ware', ar: 'أدوات تقديم', en: 'Serving ware' },
      { code: 'foodservice_equipment', ar: 'معدات', en: 'Foodservice equipment' },
    ]},
    { ar: 'التنظيف والصيانة', en: 'Maintenance', subs: [
      { code: 'cleaning_maintenance', ar: 'التنظيف والصيانة', en: 'Cleaning & maintenance' },
    ]},
  ]},

  { code: 'sports', ar: 'الرياضة والهواء الطلق', en: 'Sports & Outdoors', icon: '⚽', sections: [
    { ar: 'الرياضة', en: 'Sports', subs: [
      { code: 'fitness', ar: 'اللياقة والتمارين', en: 'Fitness' },
      { code: 'sports_gear', ar: 'مستلزمات رياضية', en: 'Sports gear' },
    ]},
  ]},
];

// ── Derived indexes / helpers ────────────────────────────────────────────────
export const CATEGORY_BY_CODE = Object.fromEntries(CATEGORY_TREE.map((c) => [c.code, c]));

// leaf subcategory code → { sub, category, section }
export const SUBCATEGORY_INDEX = (() => {
  const idx = {};
  for (const cat of CATEGORY_TREE) {
    for (const sec of cat.sections) {
      for (const sub of sec.subs) {
        idx[sub.code] = { sub, section: sec, category: cat };
      }
    }
  }
  return idx;
})();

export const ALL_SUBCATEGORIES = Object.keys(SUBCATEGORY_INDEX);

export function categoryCodeForSub(subCode) {
  return SUBCATEGORY_INDEX[subCode]?.category?.code || null;
}
export function subcategoryLabel(subCode, lang = 'ar') {
  const s = SUBCATEGORY_INDEX[subCode]?.sub;
  return s ? (lang === 'ar' ? s.ar : s.en) : subCode || '';
}
export function categoryLabel(catCode, lang = 'ar') {
  const c = CATEGORY_BY_CODE[catCode];
  return c ? (lang === 'ar' ? c.ar : c.en) : catCode || '';
}

// Seed hint: old factory `category` → most-likely new top category. The AI classifier
// refines to the leaf; this only narrows the search space for un-obvious rows.
export const OLD_CATEGORY_TO_NEW = {
  electronics: 'electronics',
  home_appliances: 'home_appliances',
  clothing: 'apparel',
  furniture: 'furniture',
  kitchen_furniture: 'furniture',
  office_furniture: 'furniture',
  home_decor: 'home_living',
  building: 'building',
  auto_parts: 'auto_parts',
  industrial_machinery: 'machinery',
  packaging: 'packaging',
  toys: 'toys',
  beauty: 'beauty',
  hospitality_supplies: 'hospitality',
  sports: 'sports',
  other: null,
};
